// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"8":"mercury-slider-slick","65":"mercury-map-osm","91":"mercury-tinycolor","167":"mercury-datepicker","348":"mercury-audio","471":"mercury-tools","519":"mercury-shariff","596":"mercury-masonry-list","615":"mercury-imageseries","773":"mercury-map-google"}[chunkId] + ".js";
};